
    <div class="row">
      <div class="col-12 col-lg-6">
        <h3>New Users</h3>
        <div class="row mb-4">
          <div class="col-lg-4 col-12">
            <div class="card">
              <div class="card-body">
                <h4>Today</h4>
                <div>Trial: {{userCountTodayTrial}}</div>
                <div>Subsbribed: {{userCountToday}}</div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-12">
            <div class="card">
              <div class="card-body">
                <h4>This Week</h4>
                <div>Trial: {{userCountThisWeekTrial}}</div>
                <div>Subscribed: {{userCountThisWeek}}</div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-12">
            <div class="card">
              <div class="card-body">
                <h4>This Month</h4>
                <div>Trial: {{userCountThisMonthTrial}}</div>
                <div>Subscribed: {{userCountThisMonth}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <h3>Users</h3>

            <div class="mb-3 d-flex justify-content-between">
              <span>
                <button type="button" class="btn btn-sm btn-outline-primary m-1"
                        [class.active]="userSearchPreset=='recentUsers'"
                        (click)="getRecentUsers()">
                  Recent Users
                </button>
                <button type="button" class="btn btn-sm btn-outline-primary m-1"
                        [class.active]="userSearchPreset=='trialUsers'"
                        (click)="getTrialUsers()">
                  Trial Users
                </button>
                <button type="button" class="btn btn-sm btn-outline-primary m-1"
                        (click)="exportUsers()">
                  Export
                </button>
              </span>
              <input #searchInput type="text" class="form-control w-300px m-1" placeholder="Search users..." />
            </div>
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Name</th>
                  <th>Created</th>
                  <th>Subscription</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let user of recentUsers?.data" (click)="navigateToUserDetail(user.id)" class="pointer">
                  <td>{{user.userName}}</td>
                  <td>{{user.firstName}} {{user.lastName}}</td>
                  <td>{{user.created | date:'short'}}</td>
                  <td>{{user.subscriptionLevel}}</td>
                </tr>
              </tbody>
            </table>
            <ngb-pagination class="d-flex justify-content-center"
                            [collectionSize]="recentUsers?.totalCount"
                            [(page)]="page"
                            [maxSize]="5"
	                          [ellipses]="false"
                            [pageSize]="recentUsers?.pageSize"
                            aria-label="Default pagination"
                            (pageChange)="searchUsers()">
            </ngb-pagination>

          </div>
        </div>
      </div>
    </div>
